<div class="switch-btn">
  <input type="checkbox" [id]="uniqueId" [checked]="value" (change)="toggleValue($event)" [disabled]="isDisabled" />
  <label class="toggle-button-switch" [for]="uniqueId"></label>
  <div class="toggle-button-text">
    <div class="toggle-button-text-on">{{ btnTextOn }}</div>
    <div class="toggle-button-text-off">{{ btnTextOff }}</div>
  </div>
</div>
